import script from "./KioskBackButton.vue?vue&type=script&setup=true&lang=js"
export * from "./KioskBackButton.vue?vue&type=script&setup=true&lang=js"

import "./KioskBackButton.vue?vue&type=style&index=0&id=14093b54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14093b54"]])

export default __exports__